import {
  ELEVATION_HAZARDS_RECEIVED,
  CLEAR_ELEVATION_HAZARDS
} from 'actions/actionTypes';

const defaultState = {
  geoJson: null
};

export default (state = defaultState, action: any) => {
  switch (action.type) {
    case ELEVATION_HAZARDS_RECEIVED:
      return {
        ...state,
        geoJson: action.payload
      };
    case CLEAR_ELEVATION_HAZARDS:
      return {
        ...state,
        ...defaultState
      };
    default:
      return state;
  }
};

